"use strict";

var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultCaspuleTermOptions = {
  stdin: true,
  stderr: true,
  stdout: true
};

var CapsuleTermAddon =
/*#__PURE__*/
function () {
  function CapsuleTermAddon(exec, options) {
    var _this = this;

    _classCallCheck(this, CapsuleTermAddon);

    this._toDistpose = [];

    this.activate = function (terminal) {
      _this._terminal = terminal;
      var disposeStdin = terminal.onData(_this.handleStdin);

      _this._exec.stderr.on('data', _this.handleStderr);

      _this._exec.stdout.on('data', _this.handleStdout);

      var disposeResize = _this._terminal.onResize(_this.resizeTerminal);

      _this._toDistpose.push(disposeStdin);

      _this._toDistpose.push({
        dispose: function dispose() {
          return _this._exec.stderr.off('data', _this.handleStderr);
        }
      });

      _this._toDistpose.push({
        dispose: function dispose() {
          return _this._exec.stdout.off('data', _this.handleStdout);
        }
      });

      _this._toDistpose.push(disposeResize);
    };

    this.resizeTerminal = function (size) {
      _this._exec.resize(size.rows, size.cols);
    };

    this.handleStdin = function (e) {
      if (!_this.options.stdin) return;

      _this._exec.stdin.write(e);
    };

    this.handleStdout = function (data) {
      if (!_this._terminal) return;
      if (!_this.options.stdout) return;

      _this._terminal.write(toTerminalFormat(data));
    };

    this.handleStderr = function (data) {
      if (!_this._terminal) return;
      if (!_this.options.stderr) return;

      _this._terminal.write(toTerminalFormat(data));
    };

    this._exec = exec;
    this.options = Object.assign({}, options, defaultCaspuleTermOptions);
  }

  _createClass(CapsuleTermAddon, [{
    key: "dispose",
    value: function dispose() {
      this._toDistpose.forEach(function (x) {
        return x.dispose();
      });

      this._toDistpose = [];
      this._terminal = undefined;
    }
  }]);

  return CapsuleTermAddon;
}();

exports.CapsuleTermAddon = CapsuleTermAddon;

function toTerminalFormat(data) {
  if (typeof data === 'string') return data;
  return new Uint8Array(data);
}